import moment from 'moment';
import React, { FC, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ApplicationStatus } from '../../models/enums/ApplicationStatus';
import { toast } from 'react-toastify';
import { ApplicationService } from '../../services/ApplicationService';
import { useApplicationStore } from '../../stores/applicationStore';
import { useTranslation } from 'react-i18next';

interface ApplicationStatusModalProps {
}

const ApplicationStatusModal = forwardRef<any, ApplicationStatusModalProps>(({ }, ref) => {

    const myModalRef = useRef<HTMLDivElement | null>(null);
    const [application, setApplication] = useState<any>(null);

    const [applicatonStatus, setApplicationStatus] = useState<string>(ApplicationStatus.Pending);
    const [note, setNote] = useState<string>('');

    const applicationService = new ApplicationService();
    const applicationStore = useApplicationStore();

    const openModal = () => {
        if (myModalRef.current) {
            // @ts-ignore: Bootstrap method
            $(myModalRef.current).modal("show");
        }
    };

    const closeModal = () => {
        if (myModalRef.current) {
            // @ts-ignore: Bootstrap method
            $(myModalRef.current).modal("hide");
        }
    };

    const handleButtonClick = () => {
        closeModal();
    };
    const { t } = useTranslation(); // useTranslation hook'unu kullanarak 't' fonksiyonuna eriş
    useImperativeHandle(ref, () => ({
        show(application: any) {
            console.log('Application:', application);
            setApplication(application);
            application.status && setApplicationStatus(application.status);
            openModal();
        },
        close() {
            closeModal();
        }
    }));

    if (!application) {
        return null;
    }



    return (
        <>
            <div className="modal fade app-status-modal" id="appStatusModal" ref={myModalRef} tabIndex={-1} data-bs-backdrop="static" aria-labelledby="appStatusModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="appStatusModalLabel">{t('appsDataTable.appDetails')}</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className='table-responsive mb-4'>
                                <table className="table table-striped">

                                    <tbody>
                                        <tr>
                                            <th scope="row">1</th>
                                            <td>{t('appsDataTable.fullname')}:</td>
                                            <td>{application?.basicInformation?.userFullName}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">2</th>
                                            <td>{t('appsDataTable.date')}:</td>
                                            <td>{application.createdAt && moment(application.createdAt).format('DD.MM.YYYY')}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">3</th>
                                            <td>{t('appsDataTable.phone')}:</td>
                                            <td>{application?.basicInformation?.userPhone}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">4</th>
                                            <td>{t('appsDataTable.email')}:</td>
                                            <td>{application?.basicInformation?.userEmail}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">5</th>
                                            <td>{t('appsDataTable.status')}:</td>
                                            <td>{(() => {
                                                 let label = "";
                                                 let badgeClass = "";
                                                 switch (application.status) {
                                                   case 'pending':
                                                     badgeClass = 'badge text-bg-warning py-2';
                                                     label = t('pending')
                                                     break;
                                                   case 'approved':
                                                    label = t('PreApplicationApproved')
                                                     badgeClass = 'badge text-bg-success py-2';
                                                     break;
                                                   case 'rejected':
                                                    label = t('PreApplicationRejected')
                                                     badgeClass = 'badge text-bg-danger py-2';
                                                     break;
                                                   case 'missing_documents':
                                                    label = t('MissingDocuments')
                                                     badgeClass = 'badge text-bg-info py-2';
                                                     break;
                                                   case 'visa_approved':
                                                    label = t('VisaApproved')
                                                     badgeClass = 'badge text-bg-success py-2';
                                                     break;
                                                   case 'visa_rejected':
                                                    label = t('VisaRejected')
                                                     badgeClass = 'badge text-bg-danger py-2';
                                                     break;
                                                   default:
                                                     badgeClass = 'badge text-bg-secondary py-2';
                                                 }
                                                 return (
                                                    <span className={badgeClass}>{label}</span>
                                                  );
                                            })()}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='col-12'>
                                    <div className="my-3">
                                        <label htmlFor="statusChangeMessage" className="form-label">{t('message')}</label>
                                        <textarea className="form-control" placeholder={t('optional')} id="statusChangeMessage" rows={4}
                                            value={note} onChange={(event) => {
                                                setNote(event.target.value);
                                            }}></textarea>
                                    </div>
                                    <label htmlFor="changeStatus w-100" className="form-label">{t('changeStatus')}</label>
                                    <select className="form-select" aria-label="Default select changeStatus" value={applicatonStatus} onChange={(event) => {
                                        setApplicationStatus(event.target.value);
                                    }}>
                                        <option value={ApplicationStatus.Pending}>{t('pending')}</option>
                                        <option value={ApplicationStatus.Approved}>{t('PreApplicationApproved')}</option>
                                        <option value={ApplicationStatus.Rejected}>{t('PreApplicationRejected')}</option>
                                        <option value={ApplicationStatus.MissingDocuments}>{t('MissingDocuments')}</option>
                                        <option value={ApplicationStatus.VisaApproved}>{t('VisaApproved')}</option>
                                        <option value={ApplicationStatus.VisaRejected}>{t('VisaRejected')}</option>
                                    </select>
                                    <button type="button" className="btn btn-primary mt-4 w-100" onClick={() => {
                                        if (applicatonStatus === application.status) {
                                            toast.warning(t('appsDataTable.statusNotChanged'));
                                            return;
                                        }
                                        applicationService.updateApplicationStatus(application.id, applicatonStatus, note).then(() => {
                                            toast.success(t('appsDataTable.statusChanged'));
                                            applicationStore.fetch(true);
                                            closeModal();
                                            setNote('');
                                            setApplicationStatus(ApplicationStatus.Pending);
                                            setApplication(null);
                                        }).catch((error) => {
                                            toast.error(t('appsDataTable.statusChangeFailed'));
                                        });
                                    }}>{t('changeStatus')}</button>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t('appsDataTable.close')}</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
});

ApplicationStatusModal.displayName = 'ApplicationStatusModal';
export default ApplicationStatusModal;